import { Dropdown, DropdownItem } from "flowbite-react";
import React, { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { useGetColumnNamesQuery } from "../dataApiSlice";
import SelectBox from "./Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";
import { nanoid } from "@reduxjs/toolkit";
import { makeDateHierarchy } from "../../../components/VizComponents/Utils/makeDatehierarchy";
import { getWorkbookProperty, setWorkbookProperty } from "../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";

const measureOption = [
  {
    label: "Maximun",
    value: "MAX",
  },
  {
    label: "Minimum",
    value: "MIN",
  },
  {
    label: "Avgrage",
    value: "AVG",
  },
  {
    label: "Sum",
    value: "SUM",
  },
  {
    label: "Count",
    value: "COUNT",
  },
  {
    label: "Count Distinct",
    value: "DISTINCT",
  },
];

const dateFormats = [
  { label: "FY 2024 (Year)", value: "%Y", dateUnit: "Year" },
  { label: "Q1 FY2024 (Quarter)", value: "%Y-%Q", dateUnit: "Quarter" },
  { label: "January (Month)", value: "%M", dateUnit: "Month" },
  { label: "WK-24 (Week)", value: "Wx", dateUnit: "Week" },
  { label: "24.01.2024 (Day)", value: "%d.%m.%Y", dateUnit: "Day" },
];

export default function DropFieldHere({
  dropFieldName,
  title,
  reduxKey,
  dataTypeAllowed,
  dataSourceID,
  dispatchItemToredux,
  dropFieldOrClickHereIsTrue,
  canDrop: isValidDrop,
}) {
  const {
    data: columnName,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetColumnNamesQuery(dataSourceID);
  // // console.log(title);
  const dispatch = useDispatch();
  // console.log(dataTypeAllowed);
  if (isLoading) {
    // console.log("loading...");
  }
  if (isError) {
    // console.log(error);
  }
  if (isSuccess) {
    // console.log(columnName);
  }
  let borderColor =
    "bg-white text-gray-700 outline-dashed outline-2 outline-gray-400";
  switch (isValidDrop) {
    case "noColor":
      borderColor =
        "bg-white text-gray-700 outline-dashed outline-2 outline-gray-400";
      break;
    case true:
      borderColor =
        "bg-[#5ac189] text-gray-950 outline-dashed outline-2 outline-[#5ac189]";
      break;
    default:
      borderColor =
        "bg-white text-gray-700 outline-dashed outline-2 outline-gray-400";
      break;
  }
  const renderColumns = () => {
    let requiredColumns = [];
    if (Array.isArray(columnName) && columnName.length) {
      switch (dataTypeAllowed) {
        case "all":
          requiredColumns = columnName.map((cItem) => {
            return {
              ...cItem,
              label: cItem.rename,
              value: cItem.rename,
            };
          });
          break;
        case "String":
          requiredColumns = columnName
            .filter((fItem) => fItem.dataType === "String")
            .map((cItem) => {
              return {
                ...cItem,
                label: cItem.rename,
                value: cItem.rename,
              };
            });
          break;
        case "Number":
          requiredColumns = columnName
            .filter((fItem) => fItem.dataType === "Number")
            .map((cItem) => {
              return {
                ...cItem,
                label: cItem.rename,
                value: cItem.rename,
              };
            });
          break;
        default:
          break;
      }
    } else {
      requiredColumns = [];
    }
    return requiredColumns;
  };
  // console.log(renderColumns());
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const [selectedMeasure, setSelectedMeasure] = useState(
    measureOption[3].value
  );
  const [selectedDateFormat, setSelectedDateFormat] = useState(
    dateFormats[0].value
  );
  // console.log(selectedMeasure);

  const [selectColumn, setSelectColumn] = useState(null);
  const selectedItem =
    selectColumn !== null
      ? renderColumns().find((rItem) => rItem.rename === selectColumn)
      : null;
  // console.log(selectedItem);
  const handleColumn = (e) => {
    // console.log(e.target.value);
    setSelectColumn(e.target.value);
  };
  const hanldeClose = () => {
    // console.log("Dropdown closed");
  };

  const handleMeasureChange = (e) => {
    // console.log(e.target.value);
    setSelectedMeasure(e.target.value);
  };
  const handleDateFormatChange = (e) => {
    // console.log(e.target.value);
    setSelectedDateFormat(e.target.value);
  };

  const hanldeColumnSave = (selectColumn) => {
    // console.log(selectedItem);
    const selectedMeasureObject = measureOption.find(
      (option) => option.value === selectedMeasure
    );
    const selectedDateFormatObject = dateFormats.find(
      (option) => option.value === selectedDateFormat
    );
    let droppedItem = null;
    if (["rows", "groupByFields"].includes(reduxKey)) {
      if (selectedItem.dataType === "String") {
        droppedItem = { ...selectedItem, nanoId: nanoid() };
      }
      if (selectedItem.dataType === "Date" && selectedDateFormatObject) {
        const temporarayDateItem = {
          ...selectedItem,
          nanoId: nanoid(),
          yearType: "FY",
          dateFormat: {
            label: selectedDateFormatObject.label,
            value: selectedDateFormatObject.value,
          },
          dateUnit: selectedDateFormatObject.dateUnit,
        };
        const hierarchyFound = hierarchy.find((hItem) => {
          return hItem.hierarchyArray.some((hAItem) => {
            if (hAItem.dataType === "Date") {
              // console.log(`${hAItem.rename}${hAItem.dateFormat.value}`);
              // console.log(
              //   `${temporarayDateItem.rename}${temporarayDateItem.dateFormat.value}`
              // );
              return (
                `${hAItem.rename}${hAItem.dateFormat.value}` ===
                `${temporarayDateItem.rename}${temporarayDateItem.dateFormat.value}`
              );
            }
          });
        });
        if (hierarchyFound) {
          const foundedHierarchyItem = hierarchyFound.hierarchyArray.find(
            (hAItem) => {
              return (
                `${hAItem.rename}${hAItem.dateFormat.value}` ===
                `${temporarayDateItem.rename}${temporarayDateItem.dateFormat.value}`
              );
            }
          );
          // console.log(foundedHierarchyItem);
          droppedItem = foundedHierarchyItem;
        } else {
          const dateHierarchyItem = makeDateHierarchy({
            isDateHierarchyTure: true,
            dataSourceID,
            rowDateItem: temporarayDateItem,
          });
          let updatedHeirarchyArray = [...hierarchy, dateHierarchyItem];
          const dateHierarchyFirstItem = dateHierarchyItem.hierarchyArray[0];
          droppedItem = dateHierarchyFirstItem;

          dispatch(
            setWorkbookProperty({
              itemInArray: false,
              key: "hierarchy",
              value: updatedHeirarchyArray, // Use the updated array
            })
          );
        }
      }
    } else if (reduxKey === "valueColumns" && selectedMeasureObject) {
      droppedItem = {
        ...selectedItem,
        nanoId: nanoid(),
        display: "bar",
        numberObject: {
          decimalPlaces: 2,
          factor: 1,
          prefix: "$",
          sufix: "M",
          mode: "Auto",
        },
        measure: selectedMeasureObject,
      };
    } else if (reduxKey === "filters") {
      if (selectedItem.dataType === "String") {
        droppedItem = { ...selectedItem, nanoId: nanoid() };
      } else if (selectedItem.dataType === "Number" && selectedMeasureObject) {
        droppedItem = {
          ...selectedItem,
          nanoId: nanoid(),
          display: "bar",
          numberObject: {
            decimalPlaces: 2,
            factor: 1,
            prefix: "$",
            sufix: "M",
            mode: "Auto",
          },
          measure: selectedMeasureObject,
        };
      }
    }
    if (droppedItem) {
      // console.log(droppedItem);
      // dispatchItemToredux(droppedItem);
    }
    // console.log(`${selectColumn.columnName} saved`);
  };
  if (dropFieldOrClickHereIsTrue) {
    return (
      <Dropdown
        label={
          <button
            className={`text-left font-normal h-6 truncate ${borderColor} rounded px-[2px] items-center flex my-[6px] w-full sm:text-xs md:text-sm truncate`}
          >
            <IoMdAdd
              className={`${isValidDrop ? "text-gray-950" : ""} text-xl`}
            />{" "}
            {dropFieldName}
          </button>
        }
        arrowIcon={false}
        dismissOnClick={true}
        placement="right-start"
        className="ml-5 w-80"
      >
        <DropdownItem className="w-full py-1 px-2 hover:bg-transparent text-black font-medium text-base">
          {title}
        </DropdownItem>
        <DropdownItem className="w-full p-0 border-b"></DropdownItem>
        <div className="px-2 text-left w-full">
          <DropdownItem className="w-full py-1 px-0 hover:bg-transparent items-center justify-start text-black font-medium text-base">
            Columns
          </DropdownItem>
          <SelectBox
            value={selectColumn}
            onChange={handleColumn}
            optionsArray={renderColumns()}
            isArrayBig={renderColumns().length > 6}
          />
        </div>
        {(selectedItem !== null && selectedItem.dataType === "Number") ||
        reduxKey === "valueColumns" ? (
          <div className="px-2 text-left w-full">
            <DropdownItem className="w-full py-1 px-0 hover:bg-transparent items-center justify-start text-black font-medium text-base">
              Measure
            </DropdownItem>
            <SelectBox
              value={selectedMeasure}
              onChange={handleMeasureChange}
              optionsArray={measureOption}
              isArrayBig={measureOption.length > 6}
            />
          </div>
        ) : null}
        {selectedItem !== null &&
        selectedItem.dataType === "Date" &&
        ["rows", "groupByFields"].includes(reduxKey) ? (
          <div className="px-2 text-left w-full">
            <DropdownItem className="w-full py-1 px-0 hover:bg-transparent items-center justify-start text-black font-medium text-base">
              Date Formats
            </DropdownItem>
            <SelectBox
              value={selectedDateFormat}
              onChange={handleDateFormatChange}
              optionsArray={dateFormats}
              isArrayBig={dateFormats.length > 6}
            />
          </div>
        ) : null}
        <DropdownItem className="w-full p-2 flex items-center justify-end gap-2 hover:bg-transparent">
          <button
            className="border rounded border-gray-300 px-2 py-1"
            onClick={hanldeClose}
          >
            Close
          </button>
          <button
            className="border rounded text-white bg-blue-950 px-2 py-1"
            onClick={() => hanldeColumnSave(selectedItem)}
          >
            Save
          </button>
        </DropdownItem>
      </Dropdown>
    );
  } else {
    return (
      <button
        className={`text-left h-6 truncate ${borderColor} rounded px-[2px] items-center  flex my-[6px] w-full text-sm`}
      >
        <IoMdAdd className={`${isValidDrop ? "text-gray-950" : ""} text-xl`} />{" "}
        {dropFieldName}
      </button>
    );
  }
}
